import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0212fc17 = () => interopDefault(import('../pages/yandbtm/index.vue' /* webpackChunkName: "pages/yandbtm/index" */))
const _4995265a = () => interopDefault(import('../pages/vacancies/index.vue' /* webpackChunkName: "pages/vacancies/index" */))
const _2ea33866 = () => interopDefault(import('../pages/cargo-landing/_.vue' /* webpackChunkName: "" */))
const _7322d9a0 = () => interopDefault(import('../pages/transport/_.vue' /* webpackChunkName: "pages/transport/_" */))
const _2ba474ba = () => interopDefault(import('../pages/transport/index.vue' /* webpackChunkName: "pages/transport/index" */))
const _10f13ec6 = () => interopDefault(import('../pages/tip-gruza/_/products.vue' /* webpackChunkName: "pages/tip-gruza/_/products" */))
const _5fb35f69 = () => interopDefault(import('../pages/tip-gruza/_/index.vue' /* webpackChunkName: "pages/tip-gruza/_/index" */))
const _6bdfb64e = () => interopDefault(import('../pages/tip-gruza/index.vue' /* webpackChunkName: "pages/tip-gruza/index" */))
const _c436ca98 = () => interopDefault(import('../pages/signup/confirm-email/index.vue' /* webpackChunkName: "pages/signup/confirm-email/index" */))
const _2f9e0a8c = () => interopDefault(import('../pages/sets/_.vue' /* webpackChunkName: "pages/sets/_" */))
const _7747f084 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _4f68f501 = () => interopDefault(import('../pages/routes/_cityfrom/_cityto/index.vue' /* webpackChunkName: "pages/routes/_cityfrom/_cityto/index" */))
const _128a056a = () => interopDefault(import('../pages/routes/_cityfrom/index.vue' /* webpackChunkName: "pages/routes/_cityfrom/index" */))
const _0fd8ffa6 = () => interopDefault(import('../pages/routes/index.vue' /* webpackChunkName: "pages/routes/index" */))
const _52fdb9f5 = () => interopDefault(import('../pages/reset-password/index.vue' /* webpackChunkName: "pages/reset-password/index" */))
const _3f887d95 = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _7bc5d33e = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _53b34b3c = () => interopDefault(import('../pages/personal-account/index.vue' /* webpackChunkName: "pages/personal-account/index" */))
const _bb7bc180 = () => interopDefault(import('../pages/otrasli/_/products.vue' /* webpackChunkName: "pages/otrasli/_/products" */))
const _05da48b4 = () => interopDefault(import('../pages/otrasli/_/index.vue' /* webpackChunkName: "pages/otrasli/_/index" */))
const _bea8e754 = () => interopDefault(import('../pages/otrasli/index.vue' /* webpackChunkName: "pages/otrasli/index" */))
const _8bf29232 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _88854fa2 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _3ba6001b = () => interopDefault(import('../pages/lk/index.vue' /* webpackChunkName: "pages/lk/index" */))
const _54caab8e = () => interopDefault(import('../pages/gruzopodemnost/_.vue' /* webpackChunkName: "pages/gruzopodemnost/_" */))
const _70159fa8 = () => interopDefault(import('../pages/gruzopodemnost/index.vue' /* webpackChunkName: "pages/gruzopodemnost/index" */))
const _65981d26 = () => interopDefault(import('../pages/events/_slug.vue' /* webpackChunkName: "pages/events/_slug" */))
const _622ada96 = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _b93cff8c = () => interopDefault(import('../pages/confirm/index.vue' /* webpackChunkName: "pages/confirm/index" */))
const _68f0bfb8 = () => interopDefault(import('../pages/cargo-rate-calculator/index.vue' /* webpackChunkName: "pages/cargo-rate-calculator/index" */))
const _734e5951 = () => interopDefault(import('../pages/articles/_slug.vue' /* webpackChunkName: "pages/articles/_slug" */))
const _7504fa99 = () => interopDefault(import('../pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _666be456 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/yandbtm",
    component: _0212fc17,
    name: "yandbtm"
  }, {
    path: "/vacancies",
    component: _4995265a,
    name: "vacancies"
  }, {
    path: "/ural/:slug",
    components: {
      default: _2ea33866
    }
  }, {
    path: "/transport/*",
    component: _7322d9a0,
    name: "transport-all"
  }, {
    path: "/transport",
    component: _2ba474ba,
    name: "transport"
  }, {
    path: "/tip-gruza/*/products",
    component: _10f13ec6,
    name: "tip-gruza-all-products"
  }, {
    path: "/tip-gruza/*",
    component: _5fb35f69,
    name: "tip-gruza-all"
  }, {
    path: "/tip-gruza",
    component: _6bdfb64e,
    name: "tip-gruza"
  }, {
    path: "/signup/confirm-email",
    component: _c436ca98,
    name: "signup-confirm-email"
  }, {
    path: "/sets/*",
    component: _2f9e0a8c,
    name: "sets-all"
  }, {
    path: "/search",
    component: _7747f084,
    name: "search"
  }, {
    path: "/routes/:cityfrom/:cityto",
    component: _4f68f501,
    name: "routes-cityfrom-cityto"
  }, {
    path: "/routes/:cityfrom",
    component: _128a056a,
    name: "routes-cityfrom"
  }, {
    path: "/routes",
    component: _0fd8ffa6,
    name: "routes"
  }, {
    path: "/reset-password",
    component: _52fdb9f5,
    name: "reset-password"
  }, {
    path: "/registration",
    component: _3f887d95,
    name: "registration"
  }, {
    path: "/product/:slug?",
    component: _7bc5d33e,
    name: "product-slug"
  }, {
    path: "/personal-account",
    component: _53b34b3c,
    name: "personal-account"
  }, {
    path: "/otrasli/*/products",
    component: _bb7bc180,
    name: "otrasli-all-products"
  }, {
    path: "/otrasli/*",
    component: _05da48b4,
    name: "otrasli-all"
  }, {
    path: "/otrasli",
    component: _bea8e754,
    name: "otrasli"
  }, {
    path: "/news/:slug",
    component: _8bf29232,
    name: "news-slug"
  }, {
    path: "/news",
    component: _88854fa2,
    name: "news"
  }, {
    path: "/lk",
    component: _3ba6001b,
    name: "lk"
  }, {
    path: "/gruzopodemnost/*",
    component: _54caab8e,
    name: "gruzopodemnost-all"
  }, {
    path: "/gruzopodemnost",
    component: _70159fa8,
    name: "gruzopodemnost"
  }, {
    path: "/events/:slug",
    component: _65981d26,
    name: "events-slug"
  }, {
    path: "/events",
    component: _622ada96,
    name: "events"
  }, {
    path: "/confirm",
    component: _b93cff8c,
    name: "confirm"
  }, {
    path: "/cargo-rate-calculator",
    component: _68f0bfb8,
    name: "cargo-rate-calculator"
  }, {
    path: "/cargo-landing/*",
    component: _2ea33866,
    name: "cargo-landing-all"
  }, {
    path: "/articles/:slug",
    component: _734e5951,
    name: "articles-slug"
  }, {
    path: "/articles",
    component: _7504fa99,
    name: "articles"
  }, {
    path: "/*",
    component: _666be456,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
